/* eslint-disable react/no-array-index-key */
import React from "react";
import { SelectableOptionButton } from "../SelectableOptionButton/SelectableOptionButton";
import { JText } from "../Text/Text";

export type SelectableListProps = {
  options?: string[] | boolean[] | number[] | any;
  disabled?: boolean;
  onChange?: (value: string | string[] | boolean | number | undefined) => void;
  value?: string | string[] | boolean | number | any | undefined;
};

export function SelectableOptionsList(props: SelectableListProps) {
  return (
    <div>
      {Array.isArray(props.value) && (
        <JText labelKey="common.multipleSelection" />
      )}

      <div className="flex flex-row flex-1 w-full">
        {props.options?.map((item: any, index: number) => {
          const isFirst = index === 0;
          const isLast = index === props.options.length - 1;
          return (
            <SelectableOptionButton
              value={item?.value}
              label={item.label ? item.label : undefined}
              selectedValue={props.value}
              onChange={props.onChange}
              isFirstElementInTheList={isFirst}
              isLastElementInTheList={isLast}
              disabled={props.disabled}
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
}
